import type React from 'react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';
import { ConfigurationsPageView } from './ConfigurationsPageView';
import { useConfigurationsPage } from './useConfigurationsPage';

/**
 * `/accounting/configurations` — the tab shell every
 * `/accounting/configurations*` URL renders.
 *
 * The Accounting experiment's second grouping: the screens that configure the
 * ledger (the fiscal calendar, the tax regime and its rates), split off from
 * the ones that report on it. Each tab owns its data and its own
 * `ErrorBoundary`, so this shell holds neither.
 */
export const ConfigurationsPage: React.FC = () => {
    const page = useConfigurationsPage();

    return (
        <div
            className="flex w-full flex-col gap-6"
            {...getNodeTestIdProp('configurations-page')}
        >
            <ConfigurationsPageView
                selectedTabId={page.selectedTabId}
                tabs={page.tabs}
            />
        </div>
    );
};
